module.exports = __webpack_public_path__ + "static/media/WebText_Battle_1.d2a751aa.png";